import React from "react";
import styled from "styled-components";

import { Palette, Metrics } from "../../vars";

interface IBaseProps {
  className?: string;
  icon: string;
}

interface IOverlayLinkProps extends IBaseProps {
  href: string;
}

interface IOverlayCollapsibleLabelProps extends IBaseProps {
  open: boolean;
  onClick: () => void;
  role: string;
}

const { Padding, FontSizes } = Metrics;

const overlayStyles = `
    display: flex;
    align-items: center;
    position: relative;
    color: ${Palette.Rebrand.Colours.P6};
    height: 64px;
    line-height: 64px;
    padding: 0 ${Padding.OVERLAY_MENU_TOGGLE_RIGHT}px 0 ${
  Padding.OVERLAY_MENU_TOGGLE_LEFT
}px;
    font-size: ${FontSizes.OVERLAY_MENU_TOGGLE_TEXT}px;
    border-bottom: 1px solid ${Palette.Rebrand.Colours.G2};
    text-decoration: none;

    .md-icon {
        color: ${Palette.Rebrand.Colours.P4};
        margin-right: 12px;
    }

    .expand {
        color: ${Palette.Rebrand.Colours.P1};
        display: inline-block;
        position: absolute;
        height: 64px;
        line-height: 64px;
        right: 0;
        padding: 0 24px;
        border-left: 1px solid ${Palette.Rebrand.Colours.G2};
        margin-right: 5px;
    }
`;

const OverlayCollapsibleLabelBase: React.FC<IOverlayCollapsibleLabelProps> = ({
  children,
  className,
  icon,
  onClick,
  open
}) => (
  <div className={className} onClick={onClick}>
    <i className="md-icon">{icon}</i>
    {children}
    <i className="md-icon expand">{open ? "remove" : "add"}</i>
  </div>
);

const OverlayLinkBase: React.FC<IOverlayLinkProps> = ({
  children,
  className,
  icon,
  href
}) => (
  <a className={className} href={href}>
    <i className="md-icon">{icon}</i>
    {children}
  </a>
);

export const OverlayCollapsibleLabel = styled(OverlayCollapsibleLabelBase)`
  ${overlayStyles};
`;
export const OverlayLink = styled(OverlayLinkBase)`
  ${overlayStyles};
`;
